import "react-datepicker/dist/react-datepicker.css";
import {BoardContainer, TitleContainer} from "../../assets/GlobalStyles";
import Media from "./Media";
import {useParams} from "react-router-dom";
import MediaList from "./List";
import MediaListDetail from "./MediaListDetail";
import styled from "styled-components";

export default function MediaManage() {
  const params = useParams()
  return (
    <MediaManagePage>
      <BoardContainer>
        <TitleContainer>
          <div>
            <h1>지면 관리</h1>
          </div>
        </TitleContainer>
        {params.id === 'media' &&
          <Media/>
        }
        {params.id === 'mediaList' &&
          <MediaList/>
        }
        {params.id === 'mediaListDetail' &&
          <MediaListDetail/>
        }
      </BoardContainer>
    </MediaManagePage>
  )
}

const MediaManagePage = styled.div`
  ${BoardContainer} {
    margin: 0;
    border-radius: 0;
    background: transparent;
  }

  ${TitleContainer} {

    h1 {
      margin: 0;
      color: rgb(32, 36, 43);
      font-size: 22px;
      font-weight: 750;
      letter-spacing: -.025em;
    }
  }
`;
